// @flow

import { connect } from "react-redux";
import React, { useCallback, useState } from "react";
import { DndContext, closestCenter, DragOverlay } from "@dnd-kit/core";
import { arrayMove } from "@dnd-kit/sortable";

import SortableList from "./SortableList";
import { updateSectionOrder } from "src/actions/orgSettings";
import Section from "./Section";

type Props = {
  sectionIds: Array<number>,
  handleOpenModal: Function,
  _updateSectionOrder: Function,
};

const Sections = ({
  sectionIds,
  handleOpenModal,
  _updateSectionOrder,
}: Props) => {
  const [activeId, setActiveId] = useState<number | null>(null);

  const handleDragStart = useCallback((event) => {
    setActiveId(event?.active?.id);
  }, []);
  const handleDragEnd = useCallback(
    (event) => {
      const { active, over } = event;

      if (!over || active.id === over.id) {
        setActiveId(null);
        return;
      }

      const oldIndex = sectionIds.indexOf(active.id);
      const newIndex = sectionIds.indexOf(over.id);
      _updateSectionOrder(arrayMove(sectionIds, oldIndex, newIndex));
      setActiveId(null);
    },
    [sectionIds, _updateSectionOrder],
  );

  return (
    <DndContext
      collisionDetection={closestCenter}
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
    >
      <SortableList items={sectionIds} handleOpenModal={handleOpenModal} />
      <DragOverlay>
        {activeId != null && (
          <Section id={activeId} handleOpenModal={handleOpenModal} />
        )}
      </DragOverlay>
    </DndContext>
  );
};

export default connect(null, { _updateSectionOrder: updateSectionOrder })(
  Sections,
);
